export const BRAND = {
  DEFAULT: '#1976D2',
  DARK: '#1565C0',
  LIGHT: '#42A5F5',
  FOCUS_RING: 'rgba(25, 118, 210, 0.2)',
  TINT: '#eff6ff',
};
